<template>
  <vue-apex-charts
    class="comBarChart"
    ref="competitionChartBar"
    type="bar"
    height="450"
    :options="chartOptionsBar"
    :series="series"
  />
</template>

<script>
import VueApexCharts from "vue-apexcharts";

const colorMap = ["#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", 
                  "#0099c6", "#dd4477", "#66aa00", "#b82e2e", "#316395", 
                  "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", 
                  "#8b0707", "#651067", "#329262", "#5574a6", "#3b3eac"];

export default {
  name: "CompetitionChartBar",
  components: {
    VueApexCharts,
  },
  data() {
    return {
      chartOptionsBar: {
        chart: {
          height: 420,
          type: "bar",
          background: '#FBFBFB',
          toolbar:{
            show: false
          },
          sparkline:{
            enabled: true
          }
        },
        grid:{
          show: true,
        },
        dataLabels: {
          enabled: true,
          fontFamily: "NanumBarunGothic !important",
          // textAnchor: 'start',
          position: 'bottom',
          offsetY: -20,
          style: {
            colors: ['#333'],
          },
          formatter: function (val, opt) {
            return Math.round(val) + "%"
          },
          dropShadow: {
            enabled: false
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        tooltip: {
          shared: true,
          followCursor: true,
          intersect: false,
          x: {
            show: true
          },
          y: {
            formatter(val){
              return val
            },
            title: {
              formatter: function () {
                return ''
              }
            },
          },
        },
        legend: {
          show: false,
          position: "top",
          horizontalAlign: "left",
          offsetX: 0,
          fontSize: "12px",
          fontFamily: "NanumBarunGothic !important",
          itemMargin: {
            horizontal: 5,
            vertical: 5,
          },
        },
        plotOptions: {
          bar: {
                barHeight: '100%',
                distributed: true,
                horizontal: false,
                dataLabels: {
                  position: 'top'
                },
              }
        },
        noData: {
          text: '분석중...',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#404040',
            fontSize: '20px',
            fontFamily: "NanumBarunGothic"
          }
        },
        colors: [
          function({ value, seriesIndex, w }) {
            if(w.globals.labels[seriesIndex] == '김문수'){
              return '#E60024'
            }else if(w.globals.labels[seriesIndex] == '이재명'){
              return '#162583'
            }else if(w.globals.labels[seriesIndex] == '이준석'){
              return '#FF7920'
            }else if(w.globals.labels[seriesIndex] == '권영국'){
              return '#F5EB1B'
            }else if(w.globals.labels[seriesIndex] == '구주와'){
              return '#E96B6F'
            }else if(w.globals.labels[seriesIndex] == '황교안' || w.globals.labels[seriesIndex] == '송진호'){
              return '#ADAEB3'
            }else if(w.globals.labels[seriesIndex] == '기타'){
              return '#808080'
            }else{
              return '#A5BFFF';
            }
          }
        ],
      },
      series: [{
        data: []
      }],
    };
  },
  props: {
    barChartData: {
      type: Array,
      default: () => [],
    },
    barChartCategory: {
      type: Array,
      default: () => [],
    },
    totalFreq: {
      type: Number,
      default: 0
    },
  },
  watch: {
    barChartData() {
      const newData = []
      for (const data of this.barChartData) {
        newData.push(data);
      }

      const newCategory = []
      for (const data of this.barChartCategory) {
          newCategory.push(data);
      }
      this.setValues(newData, newCategory, this.totalFreq)
    },
  },

  methods:{
    setHeight(value) {
      this.barChartHeight = value
    },
    setValues(newData, newCategory, totalFreq){
      this.chartOptionsBar.xaxis = {
          categories: newCategory,
          labels:{
            maxHeight: "auto",
            show: true,
          },
        }
      this.series = [{
          data: newData
        }]      
      this.chartOptionsBar.tooltip = {
        followCursor: true,
        enabled: true,
        fixed: {
          enabled: false,
        },
        x: {
          show: true
        },
        y: {
          formatter(val){
            return Math.round((val / 100) * totalFreq).toLocaleString()
          },
          title: {
            formatter: function () {
              return ''
            }
          },
        },
      }
      this.$refs.competitionChartBar.updateOptions(this.chartOptionsBar, true);
    }
  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";

.comBarChart .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title {
  font-size: 12px !important;
  font-weight: 600;
}

.comBarChart .apexcharts-canvas .apexcharts-tooltip-text {
  font-family: NanumBarunGothic !important;
  font-weight: 400;
  font-size: 10px !important;
  filter: none;
}

.comBarChart .apexcharts-tooltip-marker {
  width: 8px;
  height: 8px;
  position: relative;
  top: 0px;
  margin-right: 5px;
  border-radius: 50%;
}

.comBarChart svg{
  height: 450px;
}

</style>
